/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  // {
  //   name: 'HealthDeclaration',
  //   path: '/health-declaration/index', // 代码下架，可能不再使用
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "HealthDeclaration" */ '@/views/health-declaration/index'
  //     ),
  //   meta: { title: '健康申报' },
  // },
  {
    name: 'HealthAntigen',
    path: '/health-antigen',
    component: () =>
      import(
        /* webpackChunkName: "Health1054" */ '@/views/health-antigen/index'
      ),
    meta: { title: '抗原检测结果上传' },
  },
];
